import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { providerIdToName } from '@servicetitan/financing-utils-shared';

interface ApplicationInstructionsProps {
    technician: boolean;
}

export const ApplicationInstructions = ({ technician }: ApplicationInstructionsProps) => {
    const { setupData } = SetupDataStore.useStore();
    const { applicationSubheadingAction, technicianInstructionText } = useProviderConfig();
    const providerName = setupData?.provider ? providerIdToName(setupData?.provider) : '';
    const actionText = applicationSubheadingAction ?? `open the ${providerName} application`;

    if (!technician) {
        return <>Confirm your information to {actionText}.</>;
    }

    if (technicianInstructionText) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{technicianInstructionText}</>;
    }

    return (
        <>
            Confirm the customer's information to {actionText}. You can open the application now, or
            send an application link to the customer via email.
        </>
    );
};
